var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 31,
    viewBox: "0 0 25 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_79_67)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_79_67",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 31
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 0.5H0.5V30.5H24.5V0.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_79_67)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5 30.5C2.675 30.5 1.969 30.2065 1.382 29.6195C0.795 29.0325 0.501 28.326 0.5 27.5V3.5C0.5 2.675 0.794 1.969 1.382 1.382C1.97 0.795 2.676 0.501 3.5 0.5H21.5C22.325 0.5 23.0315 0.794 23.6195 1.382C24.2075 1.97 24.501 2.676 24.5 3.5V27.5C24.5 28.325 24.2065 29.0315 23.6195 29.6195C23.0325 30.2075 22.326 30.501 21.5 30.5H3.5ZM3.5 27.5H21.5V3.5H3.5V27.5ZM5 24.5H20L14.825 17.75L11.375 22.25L9.05 19.25L5 24.5Z",
    fill: "#EBB42C"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_79_67"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 30,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanner);
export default __webpack_public_path__ + "static/media/banner.68f9081546746bc26ec35fe3cc454ab2.svg";
export { ForwardRef as ReactComponent };